import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';

export function Spacer(props) {
  const { t } = useTranslation('common');

  const { fromProduct, spacerHeight, fromForm, dataIndex, editingInput, deleteItem, dppAddEditAccess } = props;
  let spacerContent;

  if (!spacerHeight) {
    if (fromProduct) {
      spacerContent = <div style={{ height: spacerHeight?.value || '5px' }} />;
    } else {
      spacerContent = <div className="empty-heading">{t('DPP.CONTROL.SPACER.EMPTY_TITLE')}</div>;
    }
  } else {
    spacerContent = <div className={!fromProduct && 'spacer-height'} style={{ height: spacerHeight?.value }} />;
  }

  return (
    <div className="spacer-control">
      {spacerContent}

      {!fromProduct && fromForm && (
        <CommonAction editingInput={editingInput} deleteItem={deleteItem} dataIndex={dataIndex} dppAddEditAccess={dppAddEditAccess} />
      )}
    </div>
  );
}
export default Spacer;
